import formModel from './formModel';

const {
    formField: {
        cuit,
        dni,
        numeroReferencia,
        fechaNacimiento,
        premium,
        sexo
    }
} = formModel;

export default {
    [numeroReferencia.name]: '',
    [premium.name]: '',
    [sexo.name]: '1',
    [dni.name]: '',
    [cuit.name]: '',
    [fechaNacimiento.name]: '',
};